import React from 'react';
import styled from 'styled-components';
import horizontallyCenteredSection from '../../../components/styles/horizontallyCenteredSection';
import sizeSImage from './images/size-s.jpg';

const CatalogueStyles = styled.section`
  ${horizontallyCenteredSection}
  padding-top: 5rem;
  padding-bottom: 5rem;
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  line-height: 2rem;

  && h2 {
    margin-bottom: 5rem;
  }

  && h3 {
    padding-bottom: 2rem;
    margin-bottom: 2.5rem;
    border-bottom: 1px solid var(--color-white);
  }

  && p {
    margin-bottom: 1.5rem;
    font-size: 2.5vh;
  }

  section {
    padding-bottom: 3rem;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    div {
      flex: 1;

      &:not(:first-of-type) {
        margin-left: 2rem;
      }
    }
  }
`;

const TwoOptions = styled.div`
  display: flex;
  flex-direction: column;

  &&& {
    margin: 0;
  }

  article {
    flex: 1;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Option = styled.article`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  flex-direction: column;

  div {
    margin-top: 1.5rem;
  }

  div:first-of-type {
    flex: 0;
    margin-top: 0;
  }

  div > div {
    background-color: ${({ color }) => color || 'var(--color-black)'};
    width: ${({ big }) => (big ? '7.5rem' : '4rem')};
    height: ${({ big }) => (big ? '7.5rem' : '4rem')};
    border-radius: 0.5rem;
    ${({ image }) => (image ? `background-image: url("${image}");` : '')}
    object-fit: cover;
    background-position: center center;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    div {
      margin-top: 0;
    }
  }
`;

export default function Catalogue() {
  return (
    <CatalogueStyles>
      <div>
        <h2>Technical Specs</h2>
      </div>
      <div>
        <h3>Tracking</h3>
        <section>
          <p>Sensor: PMW 3389 </p>
          <p>Type: Optical </p>
          <p>Resolution: 200-16000 dpi </p>
          <p>Zero smoothing/Acceleration/Filtering</p>
          <p>Max Acceleration: 50g Max Speed:</p>
          <p>400 IPS</p>
        </section>
        <h3>Other</h3>
        <section>
          <p>Skatepads: 100% PFTE</p>
          <p>RGB Light: 1 (Wheel)</p>
          <p>Buttons: 5</p>
          <p>Switches: Kailh GM 4.0</p>
          <p>Adjustable Lift Off</p>
          <p>Plug & Play</p>
        </section>
      </div>
    </CatalogueStyles>
  );
}
